class LowStockMessages extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const messagesObjectString = this.dataset.messagesObject
    if (!messagesObjectString) return

    let messagesObject

    try {
      messagesObject = JSON.parse(messagesObjectString)
    } catch (err) {
      console.error('Invalid JSON in data-messages-object', err)
      return
    }

    this.messagesObject = messagesObject
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      document,
      window.BAO.EVENTS.VARIANT.CHANGED,
      this.onVariantChanged.bind(this),
    )
  }

  onVariantChanged (e) {
    const variantId = e.detail.variant.id
    const inputEl = [...e.target.querySelectorAll(this.inputSelector)].find(
      el => Number(el.dataset.variantId) === variantId,
    )

    if (!inputEl) {
      this.reset()
      return
    }

    const inputQuantity = inputEl.dataset.inventoryQuantity

    this.updateMessage(inputQuantity)
  }

  updateMessage (inputQuantity) {
    const quantity = Number(inputQuantity)

    if (quantity === 0) {
      this.reset()
      return
    }

    const matchedMessage = this.messagesObject.find(
      message => quantity <= Number(message.threshold),
    )

    this.innerText = matchedMessage?.message.replace('[stock]', quantity) || ''
  }

  reset () {
    this.innerText = ''
  }

  get inputSelector () {
    return `[data-low-stock-messages-external-el="input"]`
  }
}

if (!customElements.get('low-stock-messages')) {
  customElements.define('low-stock-messages', LowStockMessages)
}
